module.exports = __webpack_public_path__ + "img/risk-send-approval.9dd2a8ad.png";